angular.module('aprima-provider-api').factory('PatientAttachmentRepository',
    ['AprimaRestangular', 'AprimaAnalytics', 'DeviceSettings', 'MetadataRepository', 'SingleAccessSet',
        function (AprimaRestangular, AprimaAnalytics, DeviceSettings, MetadataRepository, SingleAccessSet) {
            'use strict';

            var modifiedPatientIds = new SingleAccessSet();
            var defaultIgnoreCache = DeviceSettings.isPrm;

            function getPatientAttachments(patientId, restangularOptions, applicationComponent) {
                var timing = AprimaAnalytics.startTiming(applicationComponent || 'PatientAttachmentRepository', 'api', 'getPatientAttachments');

                restangularOptions = restangularOptions || {ignoreCache: defaultIgnoreCache};
                restangularOptions.ignoreCache = modifiedPatientIds.contains(patientId) || restangularOptions.ignoreCache;
                return AprimaRestangular.get(restangularOptions)
                    .one('patients', patientId)
                    .one('attachments')
                    .get()
                    .finally(timing.stop);
            }

            function getPatientAttachmentGroup(patientId, relAttachmentGroupId, restangularOptions, applicationComponent) {
                var timing = AprimaAnalytics.startTiming(applicationComponent || 'PatientAttachmentRepository', 'api', 'getPatientAttachmentGroup');

                restangularOptions = restangularOptions || {ignoreCache: defaultIgnoreCache};
                return AprimaRestangular.get(restangularOptions)
                    .one('patients', patientId)
                    .one('attachments', relAttachmentGroupId)
                    .get()
                    .finally(timing.stop);
            }

            function addPatientAttachment(patientId, patientAttachment, applicationComponent) {
                var timing = AprimaAnalytics.startTiming(applicationComponent || 'PatientAttachmentRepository', 'api', 'addPatientAttachment');

                return AprimaRestangular.get()
                    .one('patients', patientId)
                    .one('attachments')
                    .customPOST(patientAttachment)
                    .finally(timing.stop)
                    .finally(function() {
                        modifiedPatientIds.add(patientId);
                    });
            }

            function getAddPatientAttachmentMetadata($scope) {
                return MetadataRepository.getMetadata('addpatientattachment', $scope);
            }

            return {
                getPatientAttachments: getPatientAttachments,
                getPatientAttachmentGroup: getPatientAttachmentGroup,
                addPatientAttachment: addPatientAttachment,
                getAddPatientAttachmentMetadata: getAddPatientAttachmentMetadata
            };
        }]);

